<template>
    <div
        v-if="isVisible"
        class="cookie-notice"
    >

        <div class="cookie-notice__content">

            <div class="cookie-notice__text">

                <span class="cookie-notice__eyebrow">
                    {{ 'cookie_notice' | staticContentAlt }}
                </span>

                <h3>
                    {{ 'cookie_notice' | staticTitle }}
                </h3>

                <p>
                    {{ 'cookie_notice' | staticContent }}
                </p>

            </div>

            <div class="cookie-notice__actions">

                <router-link
                    to="/cookies"
                    class="cookie-notice__link"
                >
                    {{ 'cookie_notice_actions' | staticTitle }}

                    <span>
                        ↗
                    </span>
                </router-link>

                <button
                    type="button"
                    class="cookie-notice__button"
                    @click="closeNotice"
                >
                    {{ 'cookie_notice_actions' | staticContent }}
                </button>

            </div>

        </div>

    </div>
</template>

<script>
import {localStorageGet, localStorageSet} from '@/utils';
export default {
    name: 'CookieNotice',

    props: {
        cookieReadedKeyName: {
            type: String,
            default: 'cookieNoticeClosed'
        }
    },

    data() {
        return {
            isVisible: false
        };
    },

    methods: {
        closeNotice() {
            this.isVisible = false;
            localStorageSet(this.cookieReadedKeyName, 'true');
        }
    },

    beforeMount() {
        this.isVisible = localStorageGet(this.cookieReadedKeyName) !== 'true';
    }
};
</script>

<style lang="scss" scoped>
.cookie-notice {
    position: fixed;

    left: 0.875em;
    right: 0.875em;
    bottom: 0.875em;

    z-index: 9999;

    padding: 1.125em;

    background:
        linear-gradient(
            145deg,
            rgba(1, 16, 36, .98),
            rgba(13, 13, 13, .98)
        );

    border:
        0.0625em solid
        rgba(233, 81, 29, .28);

    box-shadow:
        0 1.125em 3.125em
        rgba(0, 0, 0, .35);

    backdrop-filter: blur(1em);
    -webkit-backdrop-filter: blur(1em);

    &__content {
        display: flex;
        flex-direction: column;

        gap: 1.25em;

        width: 100%;
        max-width: var(--container);

        margin: 0 auto;
    }

    &__text {
        min-width: 0;

        h3 {
            margin: 0 0 0.5em;

            color: var(--text-1);

            font-size: 1.0625em;
            font-weight: 600;
            line-height: 1.3;
        }

        p {
            max-width: 47.5em;

            margin: 0;

            color: var(--text-2);

            font-size: 0.8125em;
            line-height: 1.7;
        }
    }

    &__eyebrow {
        display: flex;
        align-items: center;

        gap: 0.625em;

        margin-bottom: 0.625em;

        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: 0.5625em;
        font-weight: 600;
        -letter-spacing: 0.125em;

        text-transform: uppercase;

        &::before {
            content: "";

            width: 1.5em;
            height: 0.0625em;

            background: var(--color-3);
        }
    }

    &__actions {
        display: flex;
        flex-direction: column;

        gap: 0.625em;
    }

    &__link,
    &__button {
        min-height: 2.875em;

        display: inline-flex;
        align-items: center;
        justify-content: center;

        gap: 1em;

        padding: 0 1.125em;

        font-family: var(--font-tech);
        font-size: 0.625em;
        font-weight: 600;
        -letter-spacing: 0.075em;

        text-transform: uppercase;

        cursor: pointer;

        transition:
            background .3s ease,
            border-color .3s ease,
            color .3s ease,
            transform .3s ease;
    }

    &__link {
        border:
            0.0625em solid
            var(--border-1);

        color: var(--text-1);

        text-decoration: none;

        span {
            color: var(--text-3);

            font-size: 0.9375em;
        }

        &:hover {
            border-color: var(--color-3);

            color: var(--text-3);

            transform: translateY(-0.125em);
        }
    }

    &__button {
        border:
            0.0625em solid
            var(--color-3);

        background: var(--color-3);

        color: var(--text-1);

        &:hover {
            background: #D74617;
            border-color: #D74617;

            transform: translateY(-0.125em);
        }
    }
}

@media (min-width: 48em) {
    .cookie-notice {
        left: 1.5em;
        right: 1.5em;
        bottom: 1.5em;

        padding: 1.25em 1.5em;

        &__content {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            gap: 2.1875em;
        }

        &__text {
            max-width: 51.25em;
        }

        &__actions {
            flex-direction: row;
            flex-shrink: 0;
        }
    }
}
</style>